import React from 'react';
import { m } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionTag } from '../ui/SectionTag';
import { pillars } from '../../data/whatYouGet';
export function WhatYouGet() {
  return <section className="bg-bg-secondary py-10 sm:py-14" data-id="element-268" data-mp="143gjy1emab8g">
      <div className="mx-auto max-w-3xl px-4 text-center sm:px-6" data-id="element-269" data-mp="100tqxx67mk9o">
        <SectionTag icon="🎁" data-id="element-270" data-mp="zzinxzkl9gjm">Lo que recibes hoy (Acceso Inmediato)</SectionTag>
        <h2 className="mt-5 font-heading text-3xl font-extrabold uppercase leading-tight text-ink sm:text-4xl" data-id="element-271" data-mp="1dza5ube87h2w">
          Todo lo que necesitas, en un solo lugar.
        </h2>
        <p className="mt-4 text-base leading-relaxed text-muted sm:text-lg" data-id="element-272" data-mp="1nqo1g8323wqr">
          Sesiones listas para que preparar tu clase deje de comerse tu tiempo.
        </p>
        <p className="mt-2 text-sm font-bold text-flash" data-id="element-273" data-mp="1wr2phf7enpxy">
          Sesiones listas · 6 Tomos · +12 Meses de clases · 100% Digital
        </p>
      </div>

      <div className="mx-auto mt-8 grid max-w-5xl gap-6 px-4 sm:px-6 lg:grid-cols-2" data-id="element-274" data-mp="1rtb12v5yylyi">
        {pillars.map((pillar, i) => <m.div key={pillar.title} initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.45,
        delay: i % 2 * 0.1
      }} className="flex flex-col rounded-2xl border border-slate-200 bg-bg-primary p-6 shadow-card sm:p-7" data-id="element-275" data-mp="2v0op32mmxavx" data-mpi={i}>
            <div className="flex items-start justify-between gap-3" data-id="element-276" data-mp="3dwoimhv9gmhm">
              <div className="flex h-11 w-11 flex-shrink-0 items-center justify-center rounded-xl bg-flash/10" data-id="element-277" data-mp="3iw10spb6t5dv">
                <pillar.icon size={22} className="text-flash" data-id="element-278" data-mp="3noaorzsqrvdi" />
              </div>
              <span className="rounded-full bg-slate-100 px-3 py-1 text-xs font-semibold text-muted" data-id="element-279" data-mp="3smvoly430d1f">
                {pillar.tag}
              </span>
            </div>
            <h3 className="mt-4 font-heading text-lg font-bold leading-snug text-ink sm:text-xl" data-id="element-280" data-mp="1e85lotbd1x1">
              {pillar.title}
            </h3>
            <div className="mt-2 flex items-baseline gap-2 text-sm" data-id="element-281" data-mp="22hha0ki4husj">
              <span className="text-muted line-through" data-id="element-282" data-mp="1xjfug9jwodlt">Valor: {pillar.value}</span>
              <span className="font-semibold text-success" data-id="element-283" data-mp="1xhcvh00rza4y">{pillar.today}</span>
            </div>
            <p className="mt-3 text-sm leading-relaxed text-muted" data-id="element-284" data-mp="2bcf9ybjou7td">{pillar.lead}</p>
            <ul className="mt-4 space-y-2.5" data-id="element-285" data-mp="26ikp34scjmsp">
              {pillar.items.map(item => <li key={item} className="flex items-start gap-2.5 text-sm leading-relaxed text-ink/90" data-id="element-286" data-mp="2l6xf7l4r6bfa">
                  <CheckIcon size={16} className="mt-0.5 flex-shrink-0 text-success" data-id="element-287" data-mp="2g9fbqa9i8oeo" />
                  <span data-id="element-288" data-mp="2u8wykk38prle">{item}</span>
                </li>)}
            </ul>
          </m.div>)}
      </div>
    </section>;
}